module.exports = __webpack_public_path__ + "img/grey-cloud.ad174397.svg";